import React from "react"

import BaseSvgIcon from "../Base"

const PensionTopUpFill = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 44 44">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.7105 14.0102H8.87047C7.92047 14.0102 7.15047 13.2402 7.15047 12.2902C7.15047 11.3402 7.92047 10.5802 8.87047 10.5802H36.2805C37.2305 10.5802 37.9905 9.82016 37.9905 8.87016C37.9905 7.92016 37.2305 7.16016 36.2805 7.16016H8.29047C5.77047 7.16016 3.73047 9.20016 3.73047 11.7202V32.2802C3.73047 34.8002 5.77047 36.8502 8.29047 36.8502H22.6405C22.0305 35.5002 21.6905 34.0102 21.6905 32.4502C21.6905 26.5202 26.5205 21.6902 32.4505 21.6902C35.5305 21.6902 38.3105 22.9902 40.2705 25.0802V18.5802C40.2705 16.0602 38.2305 14.0102 35.7105 14.0102Z"
      fill="#000"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.6996 25.6396C34.7197 25.1596 33.6196 24.8896 32.4496 24.8896C32.0196 24.8896 31.5896 24.9296 31.1796 24.9996C27.6096 25.5996 24.8896 28.7096 24.8896 32.4496C24.8896 34.0897 25.4196 35.6096 26.3096 36.8496C27.6796 38.7596 29.9197 39.9996 32.4496 39.9996C35.9197 39.9996 38.8497 37.6596 39.7197 34.4596C39.9096 33.8196 39.9996 33.1496 39.9996 32.4496C39.9996 29.4396 38.2396 26.8396 35.6996 25.6396ZM34.5896 32.9196L33.3797 32.5096V36.1297C33.3797 36.6497 32.9596 37.0696 32.4396 37.0696C31.9196 37.0696 31.5096 36.6497 31.5096 36.1297V32.5096L30.2996 32.9196C29.8296 33.0896 29.4096 32.5796 29.6596 32.1396L31.9796 28.0996C32.1896 27.7396 32.7096 27.7396 32.9096 28.0996L35.2296 32.1396C35.4796 32.5796 35.0596 33.0896 34.5896 32.9196Z"
      fill="#000"
    />
  </BaseSvgIcon>
)

export default PensionTopUpFill
